module.exports = __webpack_public_path__ + "img/bg-document-3.78aa4a84.png";